import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localTimeConverter',
  standalone: true
})
export class LocalTimeConverterPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: Date): string {
    var tempDate = new Date(value);
    var addZ = tempDate.toString().includes('GMT');

    const date = new Date(value + (addZ ? 'Z' : ''));
    
    if (date) {
      var browserLanguage = this.translate.getBrowserCultureLang();
      var v = date.toLocaleString(browserLanguage); 
      return v
    }

    return value.toDateString();
  }

}
